import { render, staticRenderFns } from "./Bareme.vue?vue&type=template&id=de6cc898&"
import script from "./Bareme.vue?vue&type=script&lang=js&"
export * from "./Bareme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports